export default __webpack_public_path__ + "static/media/ProductPageImage08.1b43213d.jpg";